import { FormGroup, ValidationErrors } from '@angular/forms';

import * as moment from 'moment';

import { Numbers } from '../../../../../app/utils/constants';
import CalendarUtilsExtended from './calendar.component.utils-extended';
import { CalendarNormalModel } from 'src/app/core/models/calendar-normal.model';

export default class CalendarUtils {
  /**
   * @ignore
   */
  constructor() {
    this.utilsExtended = new CalendarUtilsExtended();
    this.isBisiesto = this.utilsExtended.checkIsBisiesto(this.monthIni, this.yearIni);
  }

  public utilsExtended: CalendarUtilsExtended;
  public errorMax90 = false;
  public errorMax90Student = false;
  public errorMax90AVP = false;
  public errorMax70SP = false;
  public errorMax70P = false;
  public errorMax60P = false;
  public errorMax60SP = false;
  public errorMax70DI = false;
  public minDate: Date;
  public maxDateV: any;
  public monthIni: any;
  public yearIni: any;
  public valDuration = '';
  public insureSelected: string;
  public maxDate: Date;
  public readonlyEnd = false;
  public textInput2 = '';
  public textInput1 = '';
  public errorSFormat = false;
  public errorEFormat = false;
  public dateValue: Date[];
  public accumulatorDays = 0;
  public formDataUtils: FormGroup;
  public textInput3 = '';
  public dateEnd: any;
  public changeDataV = false;
  public dateStart: any;
  public fieldTouch = false;
  public fieldRequired = false;
  public fieldRequired2 = false;
  public fieldRequired3 = false;
  public fieldHasErrorB = false;
  public fieldHasErrorB2 = false;
  public fieldHasErrorB3 = false;
  public errorMin = false;
  public errorMinE = false;
  public errorMax185 = false;
  public errorMax365 = false;
  public errorMax34 = false;
  public errorMaxYear = false;
  public errorType: number = Numbers.number0;
  public isBisiesto = false;

  /**
   * Lógica central de validación de edad máxima para casos especiales de seguros.
   *
   * Según los flags recibidos, delega la validación a la función correspondiente:
   * - Si `primaSP` es true (seguro normal): delega en `olderThen90ErrorMin` (casos normales).
   * - Si no es normal pero la prima es 60 o 70 y no es deportivo: delega en `olderThen90ErrorMax` (casos especiales no deportivos).
   * - Si es deportivo: calcula si la fecha de nacimiento es anterior al máximo permitido y activa el flag `errorMax70DI`.
   *
   * Antes de delegar, limpia los flags de error de edad máxima generales.
   *
   * @param primaSP Indica si es seguro normal (boolean).
   * @param primaSport Indica si es seguro deportivo (boolean).
   * @param auxBirth2 Fecha de nacimiento del asegurado (Date).
   * @param auxDateMax Fecha límite máxima permitida (Date).
   * @param prima Tipo de prima (60 o 70).
   */
  olderThen90(primaSP: boolean, primaSport: boolean, auxBirth2: Date, auxDateMax: Date, prima: number): void {
    let primaBoolean = false;
    (prima === Numbers.number60 || prima === Numbers.number70) ? primaBoolean = true : primaBoolean = false;
    this.errorMax90 = false;
    this.errorMax90Student = false;
    this.errorMax90AVP = false;

    if (primaSP) {
      this.olderThen90ErrorMin(auxBirth2, auxDateMax, prima);
    }
    if (!primaSP && primaBoolean && !primaSport) {
      this.olderThen90ErrorMax(auxBirth2, auxDateMax, prima);
    }
    if (!primaSP && primaSport) {
      (auxBirth2.getTime() < auxDateMax.getTime()) ? this.errorMax70DI = true :  this.errorMax70DI = false;
    }
  }

  /**
   * @ignore
   */
  olderThen90ErrorMin(auxBirth2: Date, auxDateMax: Date, prima: number): void {
    this.errorMax70P = false;
    this.errorMax60P = false;
    if (auxBirth2.getTime() < auxDateMax.getTime() && prima === Numbers.number70) {
      this.errorMax70SP = true;
    }
    if (auxBirth2.getTime() < auxDateMax.getTime() && prima === Numbers.number60) {
      this.errorMax60SP = true;
    }
  }

  /**
   * Valida si la fecha de nacimiento es anterior al límite máximo permitido y activa los flags de error correspondientes
   * para primas de 70 o 60 años en seguros especiales (no normales [es decir, mayores de 70 años], no deportivos).
   *
   * - Si auxBirth2 < auxDateMax y prima === 70 → activa flag errorMax70SP.
   * - Si auxBirth2 < auxDateMax y prima === 60 → activa flag errorMax60SP.
   *
   * Estos flags se usan para mostrar mensajes de error específicos en el formulario y para bloquear la continuación
   * si la edad supera el límite permitido para ese tipo de seguro.
   *
   * @param auxBirth2 Fecha de nacimiento del asegurado (Date).
   * @param auxDateMax Fecha límite máxima permitida (Date).
   * @param prima Tipo de prima (60 o 70).
   */
  olderThen90ErrorMax(auxBirth2: Date, auxDateMax: Date, prima: number): void {
    if (auxBirth2.getTime() < auxDateMax.getTime() && prima === Numbers.number70) {
      this.errorMax70SP = true;
    }
    if (auxBirth2.getTime() < auxDateMax.getTime() && prima === Numbers.number60) {
      this.errorMax60SP = true;
    }
  }

  /**
   * @ignore
   */
  updateDefaulValue(calendar: any): void {
    let timeTo: string;
    this.minDate = calendar.value[0];
    this.maxDateV = '';
    if (this.valDuration === 'Temporal' || this.valDuration === 'form1.duration-temporal') {
      const maxV: number = this.utilsExtended.calculateMaxNumDays(this.insureSelected, this.isBisiesto);
      this.maxDate = new Date(this.minDate);
      this.maxDate.setDate(this.maxDate.getDate() + maxV);
      this.maxDateV = this.maxDate;
      this.readonlyEnd = false;
    }
    if ((this.valDuration === 'Anual' || this.valDuration === 'form1.duration-anual') ||
    (this.valDuration === 'Larga Estancia' || this.valDuration === 'form1.duration-long')) {
      this.readonlyEnd = false;
      this.maxDate = new Date(this.minDate);
      // this.maxDate.setFullYear(nextYear + 1);
      // this.maxDate.setDate(nextday - 1);
      let maxDaysYears: number = Numbers.number364;
      if (this.insureSelected === 'particularLegalAsistance' || this.insureSelected === 'ownerLegalAsistance' || this.isBisiesto) {
        maxDaysYears = Numbers.number365;
      } else {
        maxDaysYears = Numbers.number364;
      }
      this.maxDate.setDate(this.maxDate.getDate() + maxDaysYears);
      this.maxDateV = this.maxDate;
      this.readonlyEnd = true;
      timeTo = this.parseDateToShort(this.maxDate);
      this.textInput2 = timeTo;
    }
  }

  /**
   * @ignore
   */
  setReadOnly(duration: string): void {
    if ((duration === 'Anual' || duration === 'form1.duration-anual') ||
    (duration === 'Larga Estancia' || duration  === 'form1.duration-long')) {
      this.readonlyEnd = true;
    } else {
      this.readonlyEnd = false;
    }
  }

  /**
   * @ignore
   */
  parseDateToShort(fecha: Date): string {
    return !fecha ? '' : moment(fecha).format('DD/MM/YYYY');
  }

  /**
   * Prepara y ejecuta la validación de la fecha de nacimiento del asegurado según el tipo de seguro y el tipo de nacimiento.
   *
   * Esta función determina los parámetros necesarios para la validación de edad máxima permitida:
   * - Calcula el tipo de prima (60, 70, etc.) y los flags asociados (primaSport, primaSP) según el tipo de nacimiento (`typeBorn`).
   * - Ajusta la fecha límite de edad máxima según el seguro seleccionado (`insureSelected`).
   * Ejp: Para estudiantes, el límite es 90 años; para AVP no deportivo, también es 90 años;
   * Para otros casos, puede ser 80 años, para deportivos el limite es 70 años.Etc.
   * - Convierte la fecha de nacimiento del calendario y/o del campo de texto a un objeto Date normalizado.
   * - No realiza validación directa, sino que prepara el contexto y delega la lógica de validación (y marcaje de errores
   * en el formulario si corresponde) a la función `setErrorBirthErrMaxConfig`.
   *
   * @param typeBorn Tipo de nacimiento ("mayor70", "mayor60", "sport", "normal", etc.).
   * @param calendar Objeto calendario con el valor de la fecha seleccionada.
   * @param dataConfig Configuración del campo del formulario (incluye linkFormPath).
   */
  setErrorBirth(typeBorn: any, calendar: any, dataConfig: any): void {
    let prima = 70;
    const AUX_DATE_70 = new Date();
    const AUX_DATE = new Date();
    AUX_DATE_70.setFullYear(AUX_DATE.getFullYear() - Numbers.number70);

    if (typeBorn === 'mayor70') {
      prima = Numbers.number70;
    }
    if (typeBorn === 'mayor60') {
      prima = Numbers.number60;
      AUX_DATE_70.setFullYear(AUX_DATE.getFullYear() - Numbers.number60);
    }
    let primaSport = false;
    (typeBorn === 'sport') ? primaSport = true : primaSport = false;

    let primaSP = false;
    (typeBorn === 'normal') ?  primaSP = true :  primaSP = false;

    if (typeBorn === 'normal' && this.insureSelected === 'incomingStudentsTravelAsistance') {
      prima = Numbers.number60;
      AUX_DATE_70.setFullYear(AUX_DATE.getFullYear() - Numbers.number60);
    }

    const AUX_DATE_90 = new Date();
    const AUX_BIRTH: any = calendar.value;
    const AUX_BVAL: string = this.textInput3;
    const AUX_BVAL_2: any = AUX_BVAL.split('/');
    const AUX_BIRTH_I = AUX_BVAL_2[1] + '-' + AUX_BVAL_2[0] + '-' + AUX_BVAL_2[Numbers.number2];
    let auxBirth2 = new Date(AUX_BIRTH_I);
    if (AUX_BIRTH !== null) {
      auxBirth2 = new Date(AUX_BIRTH);
    }
    const ageLimit = this.insureSelected === 'particularTravelAsistance' ? Numbers.number90 : Numbers.number80;
    AUX_DATE_90.setFullYear(AUX_DATE.getFullYear() - ageLimit);
    const AUX_DATE_90_PREV: number = AUX_DATE_90.getDate();
    const AUX_DATE_90_PREV_DATE = new Date(AUX_DATE_90);
    AUX_DATE_90_PREV_DATE.setDate(AUX_DATE_90_PREV + 1);
    AUX_DATE.setHours(0, 0, 0, 0);
    auxBirth2.setHours(0, 0, 0, 0);
    AUX_DATE_70.setHours(0, 0, 0, 0);
    AUX_DATE_90_PREV_DATE.setHours(0, 0, 0, 0);
    this.setErrorBirthErrMaxConfig(dataConfig, auxBirth2, AUX_DATE_90_PREV_DATE, primaSport, primaSP, prima);
  }

  /**
   * Valida si la fecha de nacimiento del asegurado supera el límite máximo permitido según el tipo de seguro
   * y activa el flag de error correspondiente.
   *
   * Lógica:
   * - Calcula si la persona supera la edad máxima permitida usando la constante `isOverAgeLimit`.
   * - Para estudiantes (incomingStudentsTravelAsistance): si supera el límite, activa `errorMax90Student`.
   * - Para AVP (particularTravelAsistance) no deportivo: si supera el límite, activa `errorMax90AVP`.
   * - Para otros casos:
   *   - Si supera el límite y no es deportivo, activa `errorMax90` (error general de edad máxima).
   *   - Si no, delega la lógica a `olderThen90` para casos especiales (deportivos, normales, etc.).
   *
   * Si se activa cualquier flag de error de edad máxima, marca el campo como inválido en el formulario (`setErrors({ required: true })`).
   * Si no hay errores, limpia los errores del campo.
   *
   * @param dataConfig Configuración del campo del formulario (incluye linkFormPath).
   * @param auxBirth2 Fecha de nacimiento del asegurado (Date).
   * @param AUX_DATE_90_PREV_DATE Fecha límite máxima permitida para la edad (Date).
   * @param primaSport Indica si es seguro deportivo (boolean).
   * @param primaSP Indica si es seguro normal (boolean).
   * @param prima Valor numérico del tipo de prima (usado para lógica interna).
   *
   * @remarks
   * La constante `isOverAgeLimit` es true si la persona es más mayor de lo permitido (nació antes de la fecha máxima asegurada).
   */
  setErrorBirthErrMaxConfig(
    dataConfig: CalendarNormalModel,
    auxBirth2: Date,
    AUX_DATE_90_PREV_DATE: Date,
    primaSport: boolean,
    primaSP: boolean,
    prima: number
  ): void {
    const isOverAgeLimit = auxBirth2.getTime() < AUX_DATE_90_PREV_DATE.getTime();
    if (
      isOverAgeLimit &&
      this.insureSelected === 'incomingStudentsTravelAsistance'
    ) {
      this.errorMax90Student = true;
    } else if (
      isOverAgeLimit &&
      this.insureSelected === 'particularTravelAsistance' &&
      !primaSport
    ) {
      this.errorMax90AVP = true;
    } else {
      if (isOverAgeLimit && !primaSport) {
        this.errorMax90 = true;
      } else {
        this.olderThen90(
            primaSP,
            primaSport,
            auxBirth2,
            AUX_DATE_90_PREV_DATE,
            prima,
          );
      }
    }

    if (this.hasAnyMaxError()) {
      this.formDataUtils.get(dataConfig.linkFormPath).setErrors({ required: true });
    } else {
      this.setErrorBirthErrMax(dataConfig);
    }
  }

  /**
   * Devuelve true si hay algún flag de error de edad máxima activo
   */
  private hasAnyMaxError(): boolean {
    return (
      this.errorMax90 ||
      this.errorMax90Student ||
      this.errorMax90AVP ||
      this.errorMax70SP ||
      this.errorMax70P ||
      this.errorMax60P ||
      this.errorMax60SP ||
      this.errorMax70DI
    );
  }

  /**
   * @ignore
   */
  setErrorBirthErrMax(dataConfig: CalendarNormalModel): void {
    let errorsA: ValidationErrors = null;
    let errorE = false;
    const ERRORS: ValidationErrors = this.formDataUtils.get(dataConfig.linkFormPath).errors;
    if (ERRORS !== null) {
      delete ERRORS.required;
      errorE = Object.keys(ERRORS).length === 0;
    }
    (errorE === true)
      ? errorsA = null
      : errorsA = ERRORS;
    this.formDataUtils.get(dataConfig.linkFormPath).setErrors(errorsA);
    this.formDataUtils.get(dataConfig.linkFormPath).updateValueAndValidity();
  }

  /**
   * @ignore
   */
  initializeValDurationUtils1(formData: FormGroup , dataConfig: any, previousVal?: any): void {
    this.formDataUtils = formData;
    this.readonlyEnd = false;
    if (this.dateEnd === '' || this.changeDataV) {
      this.changeDataV = false;
      if (previousVal !== 'Temporal') {
        this.formDataUtils.get(dataConfig.end.linkFormPath).setValue('');
      }
    }
  }

  /**
   * @ignore
   */
  initializeValDurationUtils2(formData: FormGroup , dataConfig: any): void {
    this.formDataUtils = formData;
    let auxEVal: any = this.dateStart.split('/');
    auxEVal = new Date(auxEVal[Numbers.number1] + '-' + auxEVal[Numbers.number0] + '-' + auxEVal[Numbers.number2]);
    let initDate: Date = this.minDate;
    let maxDaysYears: number = Numbers.number364;
    if (this.dateStart !== '') {
      initDate = auxEVal;
    }
    if (this.isBisiesto) {
      maxDaysYears = Numbers.number365;
    } else {
      maxDaysYears = Numbers.number364;
    }
    this.minDate = initDate;
    this.maxDate = new Date(this.minDate);
    this.maxDate.setDate(this.maxDate.getDate() + maxDaysYears);
    this.maxDateV = this.maxDate;
    this.changeDataV = false;
    const TIME_TO_2: string = this.parseDateToShort(this.maxDate);
    this.textInput2 = TIME_TO_2;
    this.formDataUtils.get(dataConfig.end.linkFormPath).setValue(TIME_TO_2);
  }

  /**
   * @ignore
   */
  onFocusInputUtils(controlName: string[], num: number, formData: FormGroup, calType: any,
                    calendar: any, dataConfig: any, typeBorn: any): void {
    this.fieldTouch = true;
    const VALUE_EL: any = formData.get(controlName).value;
    switch (num) {
      case Numbers.number1:
        if (this.fieldRequired) {
          this.fieldHasErrorB = true;
          if (VALUE_EL !== '') {
            this.fieldHasErrorB = false;
          }
        }
        break;
      case Numbers.number2:
        if (this.fieldRequired2) {
          this.fieldHasErrorB2 = true;
          if (VALUE_EL !== '') {
            this.fieldHasErrorB2 = false;
          }
        }
        break;
      case Numbers.number3:
        if (calType === 'normal') {
          const DATE_SHORT: string = this.parseDateToShort(calendar.value);
          this.errorType = Numbers.number3;
          this.formDataUtils = formData;
          this.setErrorField(DATE_SHORT, dataConfig.linkFormPath, this.fieldHasErrorB3,
            calType, dataConfig, typeBorn, calendar);
        }
        if (this.fieldRequired3) {
          this.fieldHasErrorB3 = true;
          if (VALUE_EL !== '') {
            this.fieldHasErrorB3 = false;
          }
        }
        break;
      default:
        if (this.fieldRequired) {
          this.fieldHasErrorB = true;
          if (VALUE_EL !== '') {
            this.fieldHasErrorB = false;
          }
        }
        break;
    }
  }

  /**
   * @ignore
   */
  setErrorField(valor: any, linkFormPath: any, errorVariable: any, calType: any,
                dataConfig: any, typeBorn: any, calendar: any): void {
    let eField: any = errorVariable;
    const VALUE_FIELD: any = valor;
    const LINK_FIELD: any = linkFormPath;
    if (VALUE_FIELD !== '') {
      eField = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.formDataUtils.get(LINK_FIELD).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      errorsA = ERRORS;
      if (errorE === true) {
        errorsA = null;
      }
      this.formDataUtils.get(LINK_FIELD).setErrors(errorsA);
      this.formDataUtils.get(LINK_FIELD).updateValueAndValidity();
    } else {
      eField = true;
      this.formDataUtils.get(LINK_FIELD).setErrors({ required: true });
    }
    if (calType === 'range') {
      this.setErrorMin(linkFormPath, this.errorType, dataConfig);
    }
    if (calType === 'normal') {
      this.setErrorBirth(typeBorn, calendar, dataConfig);
    }
  }

  /**
   * @ignore
   */
  setErrorMin(linkfield: any, type: number, dataConfig: any): void {
    const NEXTDAY_I = new Date().getDate();
    const AUX_ACTUAL_DATE = new Date();
    if (dataConfig.start.linkFormPath[0] !== 'particularTravelAsistance') {
      AUX_ACTUAL_DATE.setDate(NEXTDAY_I + 1);
    }
    AUX_ACTUAL_DATE.setHours(0, 0, 0, 0);
    if (type === 1) {
      const AUX_FIELDS: any = this.formDataUtils.get(linkfield).value;
      let auxFieldSDate: any = AUX_FIELDS.split('/');
      auxFieldSDate = new Date(auxFieldSDate[1] + '-' + auxFieldSDate[0] + '-' + auxFieldSDate[Numbers.number2]);
      auxFieldSDate.setHours(0, 0, 0, 0);
      if (AUX_ACTUAL_DATE.getTime() > auxFieldSDate.getTime()) {
        this.errorMin = true;
        this.formDataUtils.get(linkfield).setErrors({ required: true });
      } else {
        this.errorMin = false;
        let errorsA: ValidationErrors = null;
        let errorE = false;
        const ERRORS: ValidationErrors = this.formDataUtils.get(linkfield).errors;
        if (ERRORS !== null) {
          delete ERRORS.required;
          errorE = Object.keys(ERRORS).length === 0;
        }
        if (errorE === true) {
          errorsA = null;
        } else {
          errorsA = ERRORS;
        }
        this.formDataUtils.get(linkfield).setErrors(errorsA);
      }
    }
    if (type === Numbers.number2) {
      const AUX_FIELDS: any = this.formDataUtils.get(dataConfig.start.linkFormPath).value;
      const AUX_FIELD_E: any = this.formDataUtils.get(dataConfig.end.linkFormPath).value;
      let auxFieldSDate: any = AUX_FIELDS.split('/');
      let auxFieldEDate: any = AUX_FIELD_E.split('/');
      auxFieldSDate = new Date(auxFieldSDate[1] + '-' + auxFieldSDate[0] + '-' + auxFieldSDate[Numbers.number2]);
      auxFieldSDate.setHours(0, 0, 0, 0);
      auxFieldEDate = new Date(auxFieldEDate[1] + '-' + auxFieldEDate[0] + '-' + auxFieldEDate[Numbers.number2]);
      auxFieldEDate.setHours(0, 0, 0, 0);
      if ((AUX_ACTUAL_DATE.getTime() > auxFieldEDate.getTime()) || auxFieldSDate.getTime() > auxFieldEDate.getTime()) {
        this.errorMinE = true;
        this.formDataUtils.get(linkfield).setErrors({ required: true });
      } else {
        this.errorMinE = false;
        let errorsA: ValidationErrors = null;
        let errorE = false;
        const ERRORS: ValidationErrors = this.formDataUtils.get(dataConfig.end.linkFormPath).errors;
        if (ERRORS !== null) {
          delete ERRORS.required;
          errorE = Object.keys(ERRORS).length === 0;
        }
        if (errorE === true) {
          errorsA = null;
        } else {
          errorsA = ERRORS;
        }
        this.formDataUtils.get(linkfield).setErrors(errorsA);
      }
    }
    if (!this.errorMin && !this.errorMinE) {
      this.setErrorMax(this.accumulatorDays, dataConfig);
    }
  }

  /**
   * @ignore
   */
  setErrorMax(valor: any, dataConfig: any): void {
    const VALUE_FIELD: any = valor;
    const INSURE_SELECTED: any = dataConfig.start.linkFormPath[0];
    const VALUE_FORM: any = this.formDataUtils.get(INSURE_SELECTED).value;
    this.valDuration = VALUE_FORM.insuranceDuration;
    if (this.valDuration === 'Temporal' || this.valDuration === 'form1.duration-temporal') {
      this.setErrorMaxTemp(VALUE_FIELD, dataConfig);
    } else if (this.valDuration === 'Anual' || this.valDuration === 'Larga Estancia') {
      this.setErrorMaxAnual(VALUE_FIELD, dataConfig);
    } else {
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.formDataUtils.get(dataConfig.end.linkFormPath).errors;
      this.errorMax185 = false;
      this.errorMax34 = false;
      this.errorMax365 = false;
      this.errorMaxYear = false;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }
      this.formDataUtils.get(dataConfig.end.linkFormPath).setErrors(errorsA);
      this.formDataUtils.get(dataConfig.end.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * @ignore
   */
  setErrorMaxTemp(valueField: any, dataConfig: any): void {
    let maxTemporalValue = 0;
    if (this.insureSelected === 'individualTravelAsistance') {
      maxTemporalValue = Numbers.number34 - 1;
    }
    if (this.insureSelected === 'particularTravelAsistance' || this.insureSelected === 'sportTravelAsistance') {
      maxTemporalValue = Numbers.number185 - 1;
    }
    if (this.insureSelected === 'incomingStudentsTravelAsistance' && this.isBisiesto) {
      maxTemporalValue = Numbers.number365;
    }
    if (this.insureSelected === 'incomingStudentsTravelAsistance' && !this.isBisiesto) {
      maxTemporalValue = Numbers.number364;
    }
    if (valueField > maxTemporalValue) {
      if (maxTemporalValue === (Numbers.number185 - 1)) {
        this.errorMax185 = true;
        this.errorMax365 = false;
        this.errorMax34 = false;
      }
      if (maxTemporalValue === (Numbers.number34 - 1)) {
        this.errorMax185 = false;
        this.errorMax365 = false;
        this.errorMax34 = true;
      }
      if (maxTemporalValue === Numbers.number364 || maxTemporalValue === Numbers.number365) {
        this.errorMax185 = false;
        this.errorMax34 = false;
        this.errorMax365 = true;
      }
      this.errorMaxYear = false;
      this.formDataUtils.get(dataConfig.end.linkFormPath).setErrors({ required: true });
    } else {
      this.errorMax185 = false;
      this.errorMax365 = false;
      this.errorMax34 = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.formDataUtils.get(dataConfig.end.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }
      this.formDataUtils.get(dataConfig.end.linkFormPath).setErrors(errorsA);
      this.formDataUtils.get(dataConfig.end.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * @ignore
   */
  setErrorMaxAnual(valueField: any, dataConfig: any): void {
    if (valueField > Numbers.number365) {
      this.errorMaxYear = true;
      this.errorMax185 = false;
      this.errorMax365 = false;
      this.errorMax34 = false;
      this.formDataUtils.get(dataConfig.end.linkFormPath).setErrors({ required: true });
    } else {
      this.errorMaxYear = false;
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.formDataUtils.get(dataConfig.end.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) {
        errorsA = null;
      } else {
        errorsA = ERRORS;
      }
      this.formDataUtils.get(dataConfig.end.linkFormPath).setErrors(errorsA);
      this.formDataUtils.get(dataConfig.end.linkFormPath).updateValueAndValidity();
    }
  }

  /**
   * @ignore
   */
  changeDates(): void {
    this.readonlyEnd = false;
    this.maxDate = new Date(this.minDate);
    this.monthIni = this.maxDate.getMonth();
    this.yearIni = this.maxDate.getFullYear();
    const isBisiesto: boolean = this.utilsExtended.checkIsBisiesto(this.monthIni, this.yearIni);
    if (isBisiesto) {
      this.maxDate.setDate(this.maxDate.getDate() + Numbers.number365);
    } else {
      this.maxDate.setDate(this.maxDate.getDate() + Numbers.number364);
    }
    this.maxDateV = this.maxDate;
    this.readonlyEnd = true;
  }
}
